import type { Infer } from 'superstruct';
import {
	array,
	assign,
	nullable,
	number,
	object,
	omit,
	optional,
	partial,
	pick,
	string,
} from 'superstruct';

import {
	ViewGoogleAdsAudienceDto,
	ViewGoogleAdsGroupTemplateDto,
	ViewGoogleAdsKeywordDto,
	ViewGoogleAdsTopicDto,
	ViewGoogleAdsUserListDto,
	ViewPromotionAssetDto,
} from '@adflow/shared/data-google-ads';
import { ViewMediaDto } from '@adflow/shared/data-media';

import { historyArrayItem } from '../history-array-item';

import { HistoryGoogleAdsAdDto } from './history-google-ads-ad.dto';

export const HistoryGoogleAdsGroupDto = assign(
	partial(omit(ViewGoogleAdsGroupTemplateDto, ['updatedAt'])),
	partial(
		object({
			topics: array(historyArrayItem(ViewGoogleAdsTopicDto)),
			audiences: array(
				historyArrayItem(omit(ViewGoogleAdsAudienceDto, ['taxonomyType']))
			),
			promotionAssets: array(historyArrayItem(ViewPromotionAssetDto)),
			images: array(
				historyArrayItem(
					pick(ViewMediaDto, ['id', 'name', 'url', 'thumbnailUrl'])
				)
			),
			structuredSnippets: array(
				historyArrayItem(
					partial(
						object({
							id: number(),
							header: string(),
							values: array(historyArrayItem(string())),
						})
					)
				)
			),
			sitelinks: array(
				historyArrayItem(
					partial(
						object({
							id: number(),
							linkText: string(),
							finalUrl: string(),
							description1: optional(nullable(string())),
							description2: optional(nullable(string())),
						})
					)
				)
			),
			calloutAssets: array(historyArrayItem(string())),
			userLists: array(historyArrayItem(ViewGoogleAdsUserListDto)),
			keywords: array(
				historyArrayItem(
					assign(
						partial(omit(ViewGoogleAdsKeywordDto, ['list'])),
						object({
							id: number(),
							name: string(),
						})
					)
				)
			),
			adTemplates: array(historyArrayItem(HistoryGoogleAdsAdDto)),
			channels: array(historyArrayItem(string())),
			// Only used to distinguish groups on UI
			groupName: optional(string()),
		})
	)
);

export type HistoryGoogleAdsGroupDto = Infer<typeof HistoryGoogleAdsGroupDto>;
